import styled from "styled-components";

const ButtonWrapper = styled.a`
  background-image: linear-gradient(#ffda60, #ff9241);
  color: #2d2d2d;
  font-size: 18px;
  font-family: "Lato";
  max-height: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  box-shadow: 0 3px 6px #00000029;
  border-radius: 4px;
  text-decoration: none;
`;

export const LargeButton = styled(ButtonWrapper)`
  width: 320px;
  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const SmallButton = styled(ButtonWrapper)`
  width: ${(props) => (props.width ? props.width : "105px")};
  height: ${(props) => (props.height ? props.height : "32px")};
  min-height: 32px;
  font-size: 15px;
`;
